import { Component, Input } from '@angular/core';
import { IGetBookingsAirResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ISummarySectorAir } from '../shared/interfaces/ISummary';
import { ITableSectorServices } from '../shared/services/table-services/table-services.service';
import { IGetEnumsService } from 'libraries/service/booking/enums/IGetEnums';
import { faClock, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'sectors-air',
    template: `
        <div class="sectors" [class.details-closed]="!detailsIsShown">
            <sector-air-summary [sector]="sector" [detailsIsShown]="detailsIsShown"></sector-air-summary>

            <div class="informations" [ngClass]="{'informations-services': view === 'services', 'hidden': !detailsIsShown}">
                <div *ngIf="view === 'details'" class="informations-content">
                    <sector-air-details
                        [sectorData]="sector"
                        [bookingData]="booking"
                        [serviceEnum]="serviceEnum">
                    </sector-air-details>
                </div>

                <div *ngIf="view === 'services'" class="informations-content">
                    <sector-air-services
                        [sectorData]="sector"
                        [bookingData]="booking"
                        [tableServices]="tableServices">
                    </sector-air-services>
                </div>
                <sector-air-group *ngIf="showBookingActions && sector && showDeleteSectorAction && view === 'details'" [sector]="sector" [sectorsChecked]="sectorsChecked"></sector-air-group>
            </div>
        </div>

        <div *ngIf="sector.time" class="time"
            [class.details-closed]="!detailsIsShown">
            <fa-icon [icon]="iconClock" aria-hidden="true"></fa-icon>
            {{ sector.time }}
        </div>
    `,
    styles: [`
        .sectors {
            display: flex;
        }

        sector-air-summary {
            background-color: #fefefe;
            display: block;
            width: 225px;
            padding: .75rem;
            border-bottom: 1px solid rgba(189, 195, 199, 0.2);
            border-right: 1px solid rgba(189, 195, 199, 0.2);
        }

        .informations-content{
            background-color: #f9f9f9;
            border-bottom: 1px solid rgba(189, 195, 199, 0.2);
            flex-grow: 1;
        }

        sector-air-group {
            display: flex;
            flex-basis: 150px;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            height: 50%;
        }

        .informations.informations-services{
            overflow-x: auto;
        }

        .informations {
            width: 100%;
            display: flex;
            flex: 1;
            background-color: #f9f9f9;
            border-right: 1px solid rgba(189, 195, 199, 0.2);
        }
        .informations.hidden {
            display: none;
        }

        .details-closed sector-air-summary, .details-closed.time {
            width: 100%;
        }

        .time {
            padding: .75rem;
            background-color: #f2f2f2;
            border: 1px solid rgba(189, 195, 199, 0.2);
            color: #848282;
        }

        .time .fa-clock-o {
            margin-right: 5px;
        }
    `]
})
export class SectorsAirComponent {
    @Input()
    public showBookingActions: boolean = true;

    @Input()
    public booking: IGetBookingsAirResponse;

    @Input()
    public sector: ISummarySectorAir;

    @Input()
    public view: string;

    @Input()
    public detailsIsShown: boolean = true;

    @Input()
    public tableServices: ITableSectorServices;

    @Input()
    public serviceEnum: IGetEnumsService[];

    @Input()
    public showDeleteSectorAction: boolean = false;

    @Input()
    public sectorsChecked: ISummarySectorAir[];

    public iconClock: IconDefinition = faClock;

}
